const m3dProductLabel = (key) => document.getElementById("m3d-product-ui-labels")?.content.querySelector(`[data-label="${key}"]`)?.textContent || "";
(() => {
  const text = (node) => (node?.innerText || node?.textContent || "").replace(/\s+/g, " ").trim();

  const setupProductTags = () => {
    const details = document.querySelector('#MainContent[data-template^="product"] .product-details');
    const sectionRoot = details?.closest(".product-information");
    if (!details || !sectionRoot) return;
    const productHandle = location.pathname.split("/products/")[1]?.split(/[/?#]/)[0] || "";
    const ownedTags = document.querySelectorAll("[data-scanner-tag]");
    const customTags = [...(ownedTags.length ? ownedTags : document.querySelectorAll(".m3d-editor-product-tag"))]
      .filter((item) => item.dataset.product === productHandle && item.dataset.label)
      .map((item) => ({ label: item.dataset.label, color: item.dataset.color || "#e8bd43" }));
    details.querySelectorAll(".m3d-product-tags").forEach((tags) => tags.remove());
    if (!customTags.length) return;
    const tags = document.createElement("div");
    tags.className = "m3d-product-tags";
    const tagPalette = ["#41b6e6", "#69d6a3", "#c4a0ff", "#ffbf69", "#ff8eaa", "#71d8d5"];
    customTags.forEach(({ label }, index) => {
      const color = tagPalette[index % tagPalette.length];
      const tag = document.createElement("span");
      tag.className = "m3d-product-tag";
      tag.textContent = label;
      tag.style.setProperty("color", color, "important");
      tag.style.setProperty("border-color", color, "important");
      tag.style.setProperty("background", `color-mix(in srgb, ${color} 18%, transparent)`, "important");
      tags.append(tag);
    });
    const price = details.querySelector("product-price");
    price ? price.after(tags) : details.prepend(tags);
  };

  const alignDetails = () => {
    if (document.querySelector('#MainContent[data-template="product.resin-details"]')) return;
    const grid = document.querySelector('#MainContent[data-template^="product"] .product-information__grid');
    const details = grid?.querySelector(".product-details");
    const mediaColumn = grid?.querySelector(".m3d-desktop-media-column");
    const media = mediaColumn?.querySelector(":scope > .product-information__media");
    if (!details || !media) return;
    if (!matchMedia("(min-width: 1100px)").matches) {
      ["height", "min-height", "max-height"].forEach((name) => details.style.removeProperty(name));
      return;
    }
    const strip = mediaColumn.querySelector(":scope > .m3d-key-specs");
    const cards = strip ? [...strip.querySelectorAll(":scope > .m3d-key-spec")] : [];
    const gap = parseFloat(getComputedStyle(mediaColumn).gap) || 0;
    const target = Math.round(media.getBoundingClientRect().height + (cards.length === 3 ? gap + strip.getBoundingClientRect().height : 0));
    if (document.querySelector(".m3d-scanner-data")) {
      details.style.setProperty("height", "auto", "important");
      details.style.setProperty("min-height", `${target}px`, "important");
      details.style.setProperty("max-height", "none", "important");
      return;
    }
    details.style.setProperty("height", `${target}px`, "important");
    details.style.setProperty("min-height", `${target}px`, "important");
    details.style.setProperty("max-height", `${target}px`, "important");
  };

  const rowsFrom = (table) => [...table.querySelectorAll("tr")]
    .map((row) => {
      /* Ignore wrapper rows created by pasted rich-text tables. */
      if (row.querySelector(":scope > td table, :scope > th table")) return null;
      const cells = [...row.querySelectorAll(":scope > th, :scope > td")];
      const values = cells.map(text).filter(Boolean);
      if (values.length < 2) return null;
      const label = values[0];
      const value = values[values.length - 1];
      if (/^(description|specifications?|characteristics?|technical specifications?|parameter|item|الوصف|المواصفات|الخصائص|المواصفات الفنية|البند)$/i.test(label)) return null;
      if (/^(description|specifications?|value|الوصف|المواصفات|القيمة)$/i.test(value)) return null;
      return { label, value, source: row };
    })
    .filter((row) => row?.label && row?.value);

  const makeFeatures = (rows) => {
    const strip = document.createElement("section");
    strip.className = "m3d-key-specs m3d-template-key-specs";
    strip.setAttribute("aria-label", m3dProductLabel("key_specs"));
    const icons = [
      '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m12 3 8 4.5v9L12 21l-8-4.5v-9L12 3Z"/><path d="m4 7.5 8 4.5 8-4.5M12 12v9"/></svg>',
      '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 15a8 8 0 1 1 16 0"/><path d="m12 15 4-5M7 19h10"/></svg>',
      '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="8"/><circle cx="12" cy="12" r="3"/><path d="M4 12H2m20 0h-2"/></svg>'
    ];
    rows.forEach(({ label, value, icon }, index) => {
      const card = document.createElement("article");
      card.className = "m3d-key-spec";
      const iconMarkup = icon ? `<img src="${icon}" alt="" loading="lazy">` : icons[index % icons.length];
      card.innerHTML = `<span class="m3d-key-spec-icon">${iconMarkup}</span><span class="m3d-key-spec-copy"><span class="m3d-key-spec-label"></span><span class="m3d-key-spec-value"></span></span>`;
      card.querySelector(".m3d-key-spec-label").textContent = label;
      card.querySelector(".m3d-key-spec-value").textContent = value;
      strip.append(card);
    });
    return strip;
  };

  const openModal = (sourceTable, title) => {
    document.querySelector(".m3d-specs-popup")?.remove();
    const popup = document.createElement("div");
    popup.className = "m3d-specs-popup";
    popup.setAttribute("role", "dialog");
    popup.setAttribute("aria-modal", "true");
    popup.setAttribute("aria-label", m3dProductLabel("product_specs"));
    popup.innerHTML = '<div class="m3d-specs-popup__panel"><button class="m3d-specs-popup__close" type="button" aria-label="Close specifications">×</button><h2></h2><div class="m3d-specs-popup__content"><div class="m3d-spec-full"><div class="rte-table-wrapper"></div></div></div></div>';
    popup.querySelector(".m3d-specs-popup__close").setAttribute("aria-label", m3dProductLabel("close_specs"));
    popup.querySelector("h2").textContent = title || m3dProductLabel("technical_specs");
    const fullTable = sourceTable.cloneNode(true);
    fullTable.hidden = false;
    fullTable.removeAttribute("hidden");
    fullTable.style.removeProperty("display");
    ["align", "border", "cellpadding", "cellspacing", "width"].forEach((attribute) => {
      fullTable.removeAttribute(attribute);
    });
    fullTable.querySelectorAll("tr").forEach((row) => {
      const cells = Array.from(row.children).filter((cell) => /^(TD|TH)$/.test(cell.tagName));
      if (cells.length === 1) {
        row.classList.add("m3d-spec-section-row");
        cells[0].colSpan = 2;
      } else if (cells.length > 1) {
        cells[0].classList.add("m3d-spec-label-cell");
        cells.slice(1).forEach((cell) => cell.classList.add("m3d-spec-value-cell"));
      }
    });
    popup.querySelector(".rte-table-wrapper").append(fullTable);
    const close = () => {
      popup.remove();
      document.documentElement.classList.remove("m3d-specs-popup-open");
    };
    popup.querySelector(".m3d-specs-popup__close").addEventListener("click", close);
    popup.addEventListener("click", (event) => event.target === popup && close());
    document.addEventListener("keydown", function escape(event) {
      if (event.key !== "Escape") return;
      document.removeEventListener("keydown", escape);
      close();
    });
    document.documentElement.classList.add("m3d-specs-popup-open");
    document.body.append(popup);
  };

  const makeSpecs = (sourceTable, rows, productTitle) => {
    const specs = document.createElement("section");
    specs.className = "m3d-spec-preview m3d-desktop-specs m3d-template-specs m3d-final-specs";
    specs.style.setProperty("margin-top", "8px", "important");
    specs.setAttribute("aria-label", m3dProductLabel("technical_specs"));
    const heading = document.createElement("h2");
    heading.textContent = m3dProductLabel("technical_specs");
    const preview = document.createElement("div");
    preview.className = "m3d-spec-preview-table";
    const table = document.createElement("table");
    const body = document.createElement("tbody");
    rows.forEach(({ label, value, source }) => {
      const row = document.createElement("tr");
      const key = document.createElement("td");
      const val = document.createElement("td");
      key.textContent = label;
      val.textContent = value;
      if (sourceTable.hasAttribute("data-m3d-scanner-specifications")) {
        const isolated = document.createElement("bdi");
        isolated.dir = "auto";
        isolated.textContent = value;
        val.replaceChildren(isolated);
      }
      if (sourceTable.hasAttribute("data-miraco-model-specs") && source) {
        const cell = source.querySelector(":scope > td");
        if (cell) val.replaceChildren(...Array.from(cell.childNodes, node => node.cloneNode(true)));
      }
      row.append(key, val);
      body.append(row);
    });
    table.append(body);
    preview.append(table);
    const button = document.createElement("button");
    button.type = "button";
    button.className = "m3d-final-specs-button";
    button.textContent = m3dProductLabel("all_specs");
    button.setAttribute("aria-haspopup", "dialog");
    button._m3dSourceTable = sourceTable;
    button._m3dProductTitle = productTitle;
    specs.append(heading, preview, button);
    return specs;
  };

  const setup = () => {
    setupProductTags();
    if (document.querySelector('#MainContent[data-template="product.resin-details"]')) return;
    if (!matchMedia("(min-width: 750px)").matches) return;
    const grid = document.querySelector('#MainContent[data-template^="product"] .product-information__grid');
    const details = grid?.querySelector(".product-details");
    const media = grid?.querySelector(".product-information__media");
    const sourceTables = [...document.querySelectorAll('#MainContent[data-template^="product"] .m3d-spec-full table, #MainContent[data-template^="product"] rte-formatter table, #MainContent[data-template^="product"] .rte table, #MainContent[data-template^="product"] .m3d-desktop-description table')]
      .filter((table) => !table.closest('.m3d-f2uv-options'));
    /* Bundle comparison tables precede the actual technical table. The final
       eligible table is therefore the canonical specifications source. */
    let sourceTable = document.querySelector("[data-m3d-scanner-specifications]") || sourceTables.at(-1) || null;
    const description = (sourceTables.at(-1) || sourceTable)?.closest("rte-formatter, .rte, .m3d-desktop-description");
    if (!grid || !details || !media) {
      alignDetails();
      return;
    }
    if (grid.dataset.m3dFinalReady === "true" && details.querySelector(".m3d-final-specs")) {
      alignDetails();
      return;
    }
    if (sourceTable) grid._m3dCanonicalSourceTable = sourceTable.cloneNode(true);
    else sourceTable = grid._m3dCanonicalSourceTable || null;
    const rows = sourceTable ? rowsFrom(sourceTable) : [];
    const autoFeatures = grid.dataset.m3dAutoFeatures === "true";
    const showSpecifications = grid.dataset.m3dShowSpecifications === "true";
    const sectionRoot = grid.closest(".product-information");
    const productHandle = location.pathname.split("/products/")[1]?.split(/[/?#]/)[0] || "";
    const config = [...document.querySelectorAll(".m3d-editor-product-config")]
      .find((item) => item.dataset.product === productHandle);
    const resolvedShowSpecifications = config
      ? config.dataset.showSpecifications === "true"
      : showSpecifications;
    const resolvedShowFeatures = config ? config.dataset.showFeatures === "true" : true;
    const customFeatures = [...document.querySelectorAll(".m3d-editor-feature")]
      .filter((item) => item.dataset.product === productHandle)
      .map((item) => ({ label: item.dataset.title || "", value: item.dataset.text || "", icon: item.dataset.icon || "" }))
      .filter((item) => item.label || item.value);
    grid.dataset.m3dFinalReady = "true";

    let mediaColumn = grid.querySelector(".m3d-desktop-media-column");
    if (!mediaColumn) {
      mediaColumn = document.createElement("div");
      mediaColumn.className = "m3d-desktop-media-column";
      media.before(mediaColumn);
      mediaColumn.append(media);
    }
    mediaColumn.querySelectorAll(":scope > .m3d-key-specs").forEach((strip) => strip.remove());
    /* Once a product has an editor configuration, its feature blocks are
       authoritative. Empty or deleted fields must never resurrect defaults. */
    const featureRows = resolvedShowFeatures
      ? (config ? customFeatures : (customFeatures.length ? customFeatures : (autoFeatures ? rows.slice(0, 3) : [])))
      : [];
    if (featureRows.length) mediaColumn.append(makeFeatures(featureRows));

    details.querySelectorAll(".m3d-spec-preview, .m3d-desktop-specs, .m3d-template-specs").forEach((specs) => specs.remove());
    if (resolvedShowSpecifications && sourceTable && rows.length) {
      const title = text(details.querySelector("h1"));
      const specs = makeSpecs(sourceTable, rows, title);
      details.append(specs);
    }

    if (sourceTable && description && description.isConnected) {
      description.querySelectorAll("table").forEach((table) => {
        /* Other description tables may contain compatibility or pack data.
           Hide only the table represented by an actual specifications panel. */
        const hasPreview = resolvedShowSpecifications && rows.length > 0
          && details.querySelector(".m3d-final-specs");
        table.classList.toggle("m3d-spec-source-hidden", table === sourceTable && Boolean(hasPreview));
      });
      description.classList.add("m3d-desktop-description");
      if (description.parentElement !== grid.parentElement || description.previousElementSibling !== grid) {
        grid.after(description);
      }
    }
    if (description && document.querySelector("[data-m3d-server-story]")) description.remove();
    requestAnimationFrame(alignDetails);
    setTimeout(alignDetails, 400);
  };

  setup();
  /* A delegated capture listener survives Shopify section reloads and legacy
     scripts that move the specifications card after it has been created. */
  document.addEventListener("click", (event) => {
    const button = event.target.closest?.(".m3d-final-specs-button");
    if (!button) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const sourceTable = button._m3dSourceTable || document.querySelector(
      '#MainContent[data-template^="product"] .m3d-spec-full table, #MainContent[data-template^="product"] .m3d-desktop-description table, #MainContent[data-template^="product"] rte-formatter table, #MainContent[data-template^="product"] .rte table'
    );
    if (!sourceTable) return;
    const title = button._m3dProductTitle || text(document.querySelector(
      '#MainContent[data-template^="product"] .product-details h1'
    ));
    openModal(sourceTable, title);
  }, true);
  document.addEventListener("shopify:section:load", () => {
    const grid = document.querySelector('#MainContent[data-template^="product"] .product-information__grid');
    if (grid) grid.dataset.m3dFinalReady = "false";
    setup();
  });
  document.addEventListener("shopify:block:select", setup);
  window.addEventListener("resize", alignDetails, { passive: true });
})();

/* F2 Ultra UV configuration comparison, kept in the editorial description
   rather than in the technical-specification source table. */
(() => {
  if (!location.pathname.includes('/products/xtool-f2-ultra-uv-5w')) return;
  const configurations = [
    ['Standalone', ['1× xTool F2 Ultra UV']],
    ['UV + Conveyor', ['1× xTool F2 Ultra UV', '1× Auto Streamline™ Conveyor']],
    ['Deluxe Bundle', ['1× xTool F2 Ultra UV', '1× Auto Streamline™ Conveyor', '1× RA3 4-in-1 Rotary', '1× SafetyPro™ AP2 Air Purifier']],
    ['Single + UV Productive Duo', ['1× F2 Ultra (Single)', '1× F2 Ultra UV']],
    ['Dual + UV Productive Duo', ['1× F2 Ultra (Dual)', '1× F2 Ultra UV']],
    ['Single + UV All-in-One Business Duo', ['1× F2 Ultra (Single)', '1× F2 Ultra UV', '1× Auto Streamline™ Conveyor', '1× SafetyPro™ AP2 Air Purifier', '1× RA3 4-in-1 Rotary']],
    ['Dual + UV All-in-One Business Duo', ['1× F2 Ultra (Dual)', '1× F2 Ultra UV', '1× Auto Streamline™ Conveyor', '1× SafetyPro™ AP2 Air Purifier', '1× RA3 4-in-1 Rotary']],
    ['P2S + UV Ultimate Business Duo', ['1× xTool P2S', '1× F2 Ultra UV', '1× SafetyPro™ AP2 Air Purifier']]
  ];

  const setup = () => {
    if (document.querySelector('[data-m3d-xtool-story], .m3d-f2uv-options')) return;
    const story = document.querySelector('#MainContent .m3d-official-product-story, #MainContent .m3d-desktop-description');
    if (!story) return;
    const section = document.createElement('section');
    section.className = 'm3d-f2uv-options m3d-product-reveal';
    section.innerHTML = '<div class="m3d-f2uv-options__intro"><span>CONFIGURATIONS</span><h2>Choose the right option</h2><p>Compare every bundle and see exactly what is included.</p></div><div class="m3d-f2uv-options__table-wrap"><table><thead><tr><th>Option</th><th>What is included</th></tr></thead><tbody></tbody></table></div>';
    const body = section.querySelector('tbody');
    configurations.forEach(([name, contents]) => {
      const row = document.createElement('tr');
      const title = document.createElement('th');
      title.scope = 'row';
      title.textContent = name;
      const included = document.createElement('td');
      const list = document.createElement('ul');
      contents.forEach((content) => {
        const item = document.createElement('li');
        item.textContent = content;
        list.append(item);
      });
      included.append(list);
      row.append(title, included);
      body.append(row);
    });
    story.append(section);
    requestAnimationFrame(() => section.classList.add('is-revealed'));
  };

  setup();
  document.addEventListener('shopify:section:load', setup);
  document.addEventListener('m3d:product-story-ready', setup);
})();

/* Keep Shopify variant media in sync with the custom square product gallery. */
(() => {
  if (!location.pathname.includes('/products/')) return;

  const setupVariantDropdowns = (root = document) => {
    const selector = '.variant-option--buttons:not(.variant-option--swatches)';
    const fieldsets = [];
    if (root.matches?.(selector)) fieldsets.push(root);
    root.querySelectorAll?.(selector).forEach((fieldset) => fieldsets.push(fieldset));
    fieldsets.forEach((fieldset) => {
      const choices = [...fieldset.querySelectorAll(':scope > .variant-option__button-label')];
      if (choices.length <= 1 || fieldset.querySelector(':scope > .m3d-variant-select')) return;
      const wrapper = document.createElement('div');
      wrapper.className = 'm3d-variant-select';
      const label = document.createElement('label');
      const id = `m3d-variant-select-${Math.random().toString(36).slice(2)}`;
      label.htmlFor = id;
      label.textContent = m3dProductLabel("choose_option");
      const select = document.createElement('select');
      select.id = id;
      choices.forEach((choice) => {
        const input = choice.querySelector('input[type="radio"]');
        if (!input) return;
        const option = document.createElement('option');
        option.value = input.value;
        option.textContent = input.value;
        option.selected = input.checked;
        option.disabled = input.dataset.optionAvailable === 'false' && !fieldset.closest('[data-m3d-filament-options]');
        select.append(option);
      });
      select.addEventListener('change', () => {
        const input = choices.map((choice) => choice.querySelector('input[type="radio"]'))
          .find((radio) => radio?.value === select.value);
        input?.click();
      });
      fieldset.addEventListener('change', (event) => {
        if (event.target.matches?.('input[type="radio"]')) select.value = event.target.value;
      });
      wrapper.append(label, select);
      fieldset.append(wrapper);
      fieldset.classList.add('m3d-variant-dropdown-ready');
    });
  };

  setupVariantDropdowns();
  document.addEventListener('shopify:section:load', (event) => setupVariantDropdowns(event.target));
  let dropdownRefreshQueued = false;
  new MutationObserver(() => {
    if (dropdownRefreshQueued) return;
    dropdownRefreshQueued = true;
    requestAnimationFrame(() => {
      dropdownRefreshQueued = false;
      setupVariantDropdowns(document);
    });
  }).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('change', () => {
    setTimeout(() => setupVariantDropdowns(document), 80);
    setTimeout(() => setupVariantDropdowns(document), 500);
  }, true);

  let productPromise;
  const getProduct = () => productPromise ||= fetch(`${location.pathname}.js`, { credentials: 'same-origin' })
    .then((response) => response.ok ? response.json() : null)
    .catch(() => null);

  let mediaSyncVersion = 0;
  const syncVariantMedia = async () => {
    const syncVersion = ++mediaSyncVersion;
    const selectedOptions = [...document.querySelectorAll('variant-picker fieldset')].map((fieldset) => fieldset.querySelector('input[type="radio"]:checked')?.value || fieldset.querySelector('select')?.value);
    const variantId = new URL(location.href).searchParams.get('variant');
    const product = await getProduct();
    if (syncVersion !== mediaSyncVersion) return;
    const selectedVariant = selectedOptions.length && selectedOptions.every(Boolean)
      ? product?.variants?.find((item) => item.options?.length === selectedOptions.length && item.options.every((value, index) => value === selectedOptions[index]))
      : null;
    const variant = selectedVariant || product?.variants?.find((item) => String(item.id) === variantId);

    const source = variant?.featured_image?.src || variant?.featured_media?.preview_image?.src;
    if (!source) return;

    const frame = document.querySelector('#MainContent[data-template^="product"] .product-information__media');
    if (frame) {
      frame.style.position = 'relative';
      const overlayHost = frame.querySelector('slideshow-slide') || frame;
      overlayHost.style.position = 'relative';
      let overlay = frame.querySelector('.m3d-variant-media-overlay');
      if (!overlay) {
        overlay = document.createElement('img');
        overlay.className = 'm3d-variant-media-overlay';
        overlay.alt = variant.title || product.title || '';
        Object.assign(overlay.style, {
          position: 'absolute', inset: '0', width: '100%', height: '100%',
          objectFit: 'contain', objectPosition: 'center', zIndex: '9999',
          pointerEvents: 'none', background: '#fff'
        });
        overlayHost.append(overlay);
      }
      overlay.alt = variant.title || product.title || '';
      overlay.src = source;
      overlay.style.display = 'block';
    }

    /* Shopify may replace the gallery asynchronously after the option change. */
    for (const delay of [0, 180, 550]) {
      if (delay) await new Promise((resolve) => setTimeout(resolve, delay));
      if (syncVersion !== mediaSyncVersion) return;
      const gallery = document.querySelector('#MainContent[data-template^="product"] media-gallery');
      if (!gallery) continue;
      const sourcePath = new URL(source, location.origin).pathname;
      const slides = [...gallery.querySelectorAll('slideshow-slide')];
      const index = slides.findIndex((slide) => [...slide.querySelectorAll('img')].some((image) => {
        try { return new URL(image.currentSrc || image.src, location.origin).pathname === sourcePath; }
        catch (_) { return false; }
      }));
      if (index >= 0 && gallery.slideshow?.select) {
        gallery.slideshow.select(index, undefined, { animate: false });
      }
      /* The custom desktop frame can keep the first rendered slide visible
         even after Horizon selects another slide. Mirror the variant media
         into that visible slide as the deterministic fallback. */
      const visibleSlide = gallery.querySelector('slideshow-slide');
      if (index < 0 || index !== 0) {
        visibleSlide?.querySelectorAll('picture source').forEach((sourceNode) => {
          sourceNode.removeAttribute('srcset');
          sourceNode.removeAttribute('sizes');
        });
        visibleSlide?.querySelectorAll('img').forEach((image) => {
          image.removeAttribute('srcset');
          image.removeAttribute('sizes');
          image.src = source;
        });
      }
    }
  };

  document.addEventListener('change', (event) => {
    if (!event.target.closest?.('variant-picker, swatches-variant-picker-component')) return;
    setTimeout(syncVariantMedia, 80);
  }, true);
  document.addEventListener('click', (event) => {
    if (!event.target.closest?.('button[aria-label="Previous slide"], button[aria-label="Next slide"], slideshow-controls button')) return;
    ++mediaSyncVersion;
    document.querySelector('.m3d-variant-media-overlay')?.style.setProperty('display', 'none');
  }, true);
  window.addEventListener('popstate', syncVariantMedia);
  syncVariantMedia();
})();

/* Shared scroll reveal for all product editorial templates. */
(() => {
  const main = document.querySelector('#MainContent[data-template^="product"]');
  if (!main) return;
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
  const roots = '#m3d-product-story, .m3d-official-product-story, .m3d-f2uv-options, .m3d-desktop-description, .m3d-in-box, .ams-supplier-story';
  const ignored = 'SCRIPT,STYLE,TEMPLATE,LINK';
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-revealed');
      observer.unobserve(entry.target);
    });
  }, {threshold: 0, rootMargin: '0px 0px -24px 0px'}) : null;
  const reveal = element => {
    if (ignored.split(',').includes(element.tagName) || element.dataset.m3dRevealReady) return;
    element.dataset.m3dRevealReady = 'true';
    element.classList.add('m3d-product-reveal');
    element.classList.remove('is-visible');
    const top = element.getBoundingClientRect().top;
    if (reducedMotion.matches || !observer || top < innerHeight - 24) element.classList.add('is-revealed');
    else observer.observe(element);
  };
  const register = () => {
    main.querySelectorAll(roots).forEach(story => {
      // Animate the content inside each row; keep alternating section backgrounds solid.
      const walk = parent => [...parent.children].forEach(element => {
        if (ignored.split(',').includes(element.tagName)) return;
        const className = typeof element.className === 'string' ? element.className : '';
        if (/__(features|videos|stats)$/.test(className) || element.tagName === 'ARTICLE' || element.classList.contains('ams-story-row')) {
          walk(element);
        } else if (/__(intro|feature|hero)(\s|$)/.test(className) && element.children.length) {
          walk(element);
        } else {
          reveal(element);
        }
      });
      walk(story);
    });
  };
  register();
  document.addEventListener('shopify:section:load', register);
  let queued = false;
  new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {queued = false; register();});
  }).observe(main, {childList:true, subtree:true});
  reducedMotion.addEventListener('change', () => {
    if (!reducedMotion.matches) return;
    main.querySelectorAll('.m3d-product-reveal').forEach(el => el.classList.add('is-revealed'));
    observer?.disconnect();
  });
})();

/* Carry the selected filament configuration into the existing quote link. */
document.addEventListener('click', (event) => {
  const link = event.target.closest?.('a[href*="contact?product="]');
  const picker = document.querySelector('variant-picker[data-m3d-filament-options]');
  if (!link || !picker) return;
  const destination = new URL(link.href, location.origin);
  const variant = new URL(location.href).searchParams.get('variant');
  if (variant) destination.searchParams.set('variant', variant);
  const choices = [...picker.querySelectorAll('input[type="radio"]:checked')].map(input => input.value);
  if (choices.length) destination.searchParams.set('configuration', choices.join(' / '));
  link.href = destination.href;
}, true);
